module.exports = __webpack_public_path__ + "img/linkedin.30c453b7.png";